import { Pipe, PipeTransform, OnDestroy } from '@angular/core';
import { LocalizationService } from '../services/localizationService';
import { Subscription } from 'rxjs';
/*
 * Raise the value exponentially
 * Takes an exponent argument that defaults to 1.
 * Usage:
 *   value | exponentialStrength:exponent
 * Example:
 *   {{ 2 | exponentialStrength:10 }}
 *   formats to: 1024
*/
@Pipe({
  name: 'localize',
  standalone: true,
  pure: false
})
export class LocalizationPipe implements PipeTransform, OnDestroy {
  private lastKey: string = '';
  private lastValue: string = '';
  private subscription: Subscription;
  
  constructor(private localizationService: LocalizationService) {
    this.subscription = this.localizationService.currentLang.subscribe(() => {
      this.lastKey = '';
    });
  }
  
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  transform(key: string): string {
    if(!key) {
      return '';
    }
    
    if (this.lastKey === key) {
      return this.lastValue;
    }
    
    this.lastKey = key;
    this.lastValue = this.localizationService.getLocalizationValue(key);
    
    return this.lastValue;
  }
}
